/*
auto-generated by: https://github.com/pmndrs/gltfjsx
*/
import React, { useRef } from "react";
import { useGLTF } from "@react-three/drei";

export default function Model(props) {
  const group = useRef();
  const { nodes, materials } = useGLTF("/modelli/stand_collo.glb");

  const { tessuto, bottoni, asole, opa, matBottone, club } = props;

  return (
    <group ref={group} {...props} dispose={null}>
      <group
        position={[0, 0.325, 0.02]}
        rotation={[1.7, 0.21, -0.03]}
        userData={{ name: "Node_25" }}
      >
        <mesh
          material={materials.Material5126}
          geometry={nodes.MatShape_3063_Node.geometry}
          userData={{ name: "MatShape_3063_Node" }}
          scale={[0.5, 0.5, 0.5]}
        >
          <meshMatcapMaterial
            attach="material"
            matcap={matBottone}
            color={bottoni}
          />
        </mesh>
      </group>
      <mesh
        material={materials["FABRIC 1_FRONT_12350"]}
        geometry={nodes.Collar_Stand_Node.geometry}
        userData={{ name: "Collar_Stand_Node" }}
        position={[0, 0.002, 0]}
        rotation={[0, 0.03, 0]}
      >
        <meshStandardMaterial
          map={!club ? tessuto : null}
          roughness={1}
          toneMapped={false}
        />
      </mesh>
      <mesh
        material={materials.PT_FABRIC_FRONT_1815}
        geometry={nodes.MatShape_11510_Node.geometry}
        userData={{ name: "MatShape_11510_Node" }}
        position={[0, 0.324, 0.0178]}
        rotation={[0, 0.3, 0.1]}
        scale={[0.884, 0.995, 0.656]}
      >
        <meshStandardMaterial color={asole} transparent={true} opacity={opa} />
      </mesh>
    </group>
  );
}

useGLTF.preload("/modelli/stand_collo.glb");
